import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import { HandleOwner as t } from "../../../core/HandleOwner.js";
import r from "../../../core/Handles.js";
import { someMap as o } from "../../../core/MapUtils.js";
import { isSome as n, unwrap as i, isNone as a } from "../../../core/maybe.js";
import { eachAlwaysValues as s, throwIfAborted as c } from "../../../core/promiseUtils.js";
import { init as u } from "../../../core/watchUtils.js";
import { property as l } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as d } from "../../../core/accessorSupport/decorators/subclass.js";
import { c as p } from "../../../chunks/vec3f64.js";
import { RayConstraint as h } from "./SnappingConstraint.js";
import { sortCandidatesInPlace as g, anyMapPointToRender as y, anyMapPointToScreenPoint as f } from "./snappingUtils.js";
import { EdgeSnappingCandidate as S } from "./candidates/EdgeSnappingCandidate.js";
import { FeatureSnappingCandidate as m } from "./candidates/FeatureSnappingCandidate.js";
import { RightAngleSnappingCandidate as v } from "./candidates/RightAngleSnappingCandidate.js";

var w = /*#__PURE__*/function (_t) {
  _inherits(w, _t);

  var _super = _createSuper(w);

  function w(e) {
    var _this;

    _classCallCheck(this, w);

    _this = _super.call(this, e), _this.sourceModules = {
      featureService: {
        module: null,
        loader: null
      },
      featureCollection: {
        module: null,
        loader: null
      },
      graphics: {
        module: null,
        loader: null
      }
    };
    return _this;
  }

  _createClass(w, [{
    key: "updating",
    get: function get() {
      return o(this.snappingSources, function (_ref) {
        var e = _ref.snappingSource;
        return e.updating;
      }) || this.updatingHandles.updating;
    }
  }, {
    key: "snappingSources",
    get: function get() {
      var e;
      var t = this._get("snappingSources") || new Map(),
          r = new Map();

      if (null != (e = this.options) && e.featureSources) {
        var _iterator = _createForOfIteratorHelper(this.options.featureSources.items),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _o = _step.value;

            var _e = _o.layer.uid,
                _i = t.get(_e);

            if (_i) {
              t.delete(_e), r.set(_e, _i);
              continue;
            }

            if (!_o.layer.loaded) {
              this.updatingHandles.addPromise(_o.layer.load());
              continue;
            }

            var _a = this.createSourceInfo(_o);

            n(_a) && r.set(_e, _a);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var _iterator2 = _createForOfIteratorHelper(t),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              _o2 = _step2$value[1];

          _o2.destroy();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return r;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.updatingHandles.add(this, "snappingSources", function () {
        _this2.notifyChange("updating");
      }, 1), n(this.view) && this.handles.add([this.view.on("layerview-create", function (e) {
        return _this2.updateLayerView(e.layer, e.layerView);
      }), this.view.on("layerview-destroy", function (e) {
        return _this2.updateLayerView(e.layer, null);
      })]);
    }
  }, {
    key: "updateLayerView",
    value: function updateLayerView(e, t) {
      var _iterator3 = _createForOfIteratorHelper(this.snappingSources),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              _r = _step3$value[1];

          _r.snappingSource.layerSource.layer === e && (_r.layerView = t);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._set("options", null);

      var _iterator4 = _createForOfIteratorHelper(this.snappingSources),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              _e2 = _step4$value[1];

          _e2.destroy();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "fetchCandidates",
    value: function () {
      var _fetchCandidates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, r) {
        var _this3 = this;

        var o, i, a, _iterator5, _step5, _loop, u;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.options.effectiveFeatureEnabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", []);

              case 2:
                o = [], i = this.computeScreeenSizeDistanceParameters(e, t), a = {
                  distance: i,
                  point: e,
                  coordinateHelper: t.coordinateHelper,
                  types: this.types,
                  filter: null
                };
                _iterator5 = _createForOfIteratorHelper(this.snappingSources);

                try {
                  _loop = function _loop() {
                    var _step5$value = _slicedToArray(_step5.value, 2),
                        _step5$value$ = _step5$value[1],
                        s = _step5$value$.snappingSource,
                        c = _step5$value$.layerView;

                    !s.layerSource.enabled || n(c) && c.suspended || o.push(s.fetchCandidates(a, r).then(function (e) {
                      return e.filter(function (e) {
                        return !_this3.candidateIsExcluded(s, e, t.excludeFeature);
                      });
                    }));
                  };

                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    _loop();
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                _context.next = 7;
                return s(o);

              case 7:
                u = _context.sent.flat();
                return _context.abrupt("return", (this.addRightAngleCandidates(u, e, i, t), c(r), g(e, u), u));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCandidates(_x, _x2, _x3) {
        return _fetchCandidates.apply(this, arguments);
      }

      return fetchCandidates;
    }()
  }, {
    key: "addRightAngleCandidates",
    value: function addRightAngleCandidates(e, t, r, o) {
      var a, s, c, u, l, d, p, h;
      var g = n(o.vertexHandle) ? null == (a = o.vertexHandle.rightEdge) || null == (s = a.rightVertex) ? void 0 : s.pos : n(o.editGeometryOperations) && "polygon" === o.editGeometryOperations.data.type ? null == (c = i(null == (u = o.editGeometryOperations.data.components[0]) ? void 0 : u.getFirstVertex())) ? void 0 : c.pos : null,
          y = n(o.vertexHandle) ? null == (l = o.vertexHandle.leftEdge) || null == (d = l.leftVertex) ? void 0 : d.pos : n(o.editGeometryOperations) ? null == (p = i(null == (h = o.editGeometryOperations.data.components[0]) ? void 0 : h.getLastVertex())) ? void 0 : p.pos : null,
          f = e.length;

      for (var _n = 0; _n < f; _n++) {
        this.addRightAngleCandidate(e[_n], y, t, r, o, e), this.addRightAngleCandidate(e[_n], g, t, r, o, e);
      }
    }
  }, {
    key: "addRightAngleCandidate",
    value: function addRightAngleCandidate(e, t, r, o, n, i) {
      if (a(t) || !(e instanceof S)) return;
      var s = e.constraint.closestTo(t),
          c = (s[0] - r[0]) / o.x,
          u = (s[1] - r[1]) / o.y;

      if (c * c + u * u <= 1) {
        var _r2 = n.coordinateHelper;
        i.push(new v({
          coordinateHelper: _r2,
          targetPoint: s,
          otherVertex: t,
          otherVertexType: 0,
          previousVertex: e.constraint.start,
          constraint: new h(_r2, t, s),
          objectId: e.objectId
        }));
      }
    }
  }, {
    key: "computeScreeenSizeDistanceParameters",
    value: function computeScreeenSizeDistanceParameters(e, t) {
      var r = this.options.distance * ("touch" === t.pointer ? this.options.touchSensitivityMultiplier : 1);
      return a(this.view) ? {
        x: r,
        y: r
      } : "2d" === this.view.type ? {
        x: r * this.view.resolution,
        y: r * this.view.resolution
      } : this.computeScreeenSizeDistanceParameters3D(e, r, this.view, t);
    }
  }, {
    key: "computeScreeenSizeDistanceParameters3D",
    value: function computeScreeenSizeDistanceParameters3D(e, t, r, o) {
      var n = o.coordinateHelper,
          i = o.elevationInfo,
          a = r.state.camera.computeScreenPixelSizeAt(y(e, n, i, r, x)) * r.renderCoordsHelper.unitInMeters / r.mapCoordsHelper.unitInMeters,
          s = t * a;
      return {
        x: s / this.computeScreenMagnitudeOfMapOffset(e, a, 0, r, o),
        y: s / this.computeScreenMagnitudeOfMapOffset(e, 0, a, r, o)
      };
    }
  }, {
    key: "computeScreenMagnitudeOfMapOffset",
    value: function computeScreenMagnitudeOfMapOffset(e, t, r, o, _ref2) {
      var n = _ref2.coordinateHelper,
          i = _ref2.elevationInfo;
      var a = n.clone(e);
      a[0] += t, a[1] += r;
      var s = f(e, n, i, o),
          c = f(a, n, i, o),
          u = c.x - s.x,
          l = c.y - s.y;
      return Math.sqrt(u * u + l * l);
    }
  }, {
    key: "types",
    get: function get() {
      return 3;
    }
  }, {
    key: "candidateIsExcluded",
    value: function candidateIsExcluded(e, t, r) {
      if (a(r)) return !1;
      var o = this.getCandidateObjectId(t);
      if (a(o)) return !1;
      var n = e.layerSource.layer;
      return "graphics" === n.type ? r.uid === o : r.sourceLayer === n && !(!r.attributes || !("objectIdField" in n)) && r.attributes[n.objectIdField] === o;
    }
  }, {
    key: "getCandidateObjectId",
    value: function getCandidateObjectId(e) {
      return e instanceof m ? e.objectId : null;
    }
  }, {
    key: "createSourceInfo",
    value: function createSourceInfo(e) {
      var _this4 = this;

      var t = this.createFeatureSnappingSourceType(e);
      if (a(t)) return null;
      if ("loading" in t) return this.updatingHandles.addPromise(t.loading.then(function () {
        _this4.destroyed || _this4.notifyChange("snappingSources");
      })), null;
      var r = n(this.view) ? this.view.allLayerViews.find(function (t) {
        return t.layer === e.layer;
      }) : null;
      return new j(t.source, r);
    }
  }, {
    key: "createFeatureSnappingSourceType",
    value: function createFeatureSnappingSourceType(e) {
      switch (e.layer.type) {
        case "feature":
        case "geojson":
        case "csv":
        case "subtype-group":
        case "wfs":
          return this.createFeatureSnappingSourceFeatureLayer(e);

        case "graphics":
          return this.createFeatureSnappingSourceGraphicsLayer(e);
      }

      return null;
    }
  }, {
    key: "createFeatureSnappingSourceFeatureLayer",
    value: function createFeatureSnappingSourceFeatureLayer(e) {
      switch (e.layer.source.type) {
        case "feature-layer":
          {
            var _t2 = this.getSourceModule("featureService");

            return n(_t2.module) ? {
              source: new _t2.module.FeatureServiceSnappingSource({
                spatialReference: this.spatialReference,
                view: this.view,
                layerSource: e
              })
            } : {
              loading: _t2.loader
            };
          }

        case "memory":
        case "csv":
        case "geojson":
        case "wfs":
          {
            if ("mesh" === e.layer.geometryType) return null;

            var _t3 = this.getSourceModule("featureCollection");

            return n(_t3.module) ? {
              source: new _t3.module.FeatureCollectionSnappingSource({
                layerSource: e
              })
            } : {
              loading: _t3.loader
            };
          }
      }

      return null;
    }
  }, {
    key: "createFeatureSnappingSourceGraphicsLayer",
    value: function createFeatureSnappingSourceGraphicsLayer(e) {
      var t = this.getSourceModule("graphics");
      return n(t.module) ? {
        source: new t.module.GraphicsSnappingSource({
          spatialReference: this.spatialReference,
          view: this.view,
          layerSource: e
        })
      } : {
        loading: t.loader
      };
    }
  }, {
    key: "getSourceModule",
    value: function getSourceModule(e) {
      var t = this.sourceModules[e];

      if (a(t.loader)) {
        var _r3 = this.loadSourceModule(e).then(function (e) {
          t.module = e;
        });

        return t.loader = _r3, {
          module: t.module,
          loader: _r3
        };
      }

      return {
        module: t.module,
        loader: t.loader
      };
    }
  }, {
    key: "loadSourceModule",
    value: function loadSourceModule(e) {
      switch (e) {
        case "featureService":
          return this.updatingHandles.addPromise(import("./featureSources/FeatureServiceSnappingSource.js"));

        case "featureCollection":
          return this.updatingHandles.addPromise(import("./featureSources/FeatureCollectionSnappingSource.js"));

        case "graphics":
          return this.updatingHandles.addPromise(import("./featureSources/GraphicsSnappingSource.js"));
      }

      return null;
    }
  }]);

  return w;
}(t);

e([l({
  constructOnly: !0
})], w.prototype, "spatialReference", void 0), e([l({
  constructOnly: !0
})], w.prototype, "view", void 0), e([l()], w.prototype, "options", void 0), e([l({
  readOnly: !0
})], w.prototype, "updating", null), e([l({
  readOnly: !0
})], w.prototype, "snappingSources", null), w = e([d("esri.views.interactive.snapping.FeatureSnappingEngine")], w);

var j = /*#__PURE__*/function () {
  function j(e, t) {
    _classCallCheck(this, j);

    this.snappingSource = e, this.layerView = t, this.handles = new r();
    var o = this.snappingSource.layerSource.layer;

    if ("refresh" in o) {
      var _t4 = o;
      this.handles.add(_t4.on("refresh", function () {
        return e.refresh();
      }));
    }

    this.handles.add([u(e, "updating", function (t) {
      return e.layerSource.updating = t;
    }, !0), u(e, "availability", function (t) {
      return e.layerSource.availability = t;
    }, !0)]);
  }

  _createClass(j, [{
    key: "destroy",
    value: function destroy() {
      this.snappingSource.destroy(), this.handles.destroy();
    }
  }]);

  return j;
}();

var x = p();
export { w as FeatureSnappingEngine };